import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Segment, Button, Dropdown, Form, Divider, List, Icon} from 'semantic-ui-react';
import {Actions} from './../../../../common/actions';

const CalendarFilters = ({
  currentYear,
  setCurrentYear,
  yearOptions,
  filters,
  options,
  onFilterChange,
  onClear,
  totalCount,
  selectedData,
  dealers,
  areaId,
  isDealerDisabled,
}) => {
  const dispatch = useDispatch();
  const coursesFilter = useSelector((state) => state.wtsCoursesFilter?.list || []);

  useEffect(() => {
    if (areaId) {
      dispatch(Actions.getWtsCoursesFilter({'area': areaId}));
    }
  }, [areaId, dispatch]);

  useEffect(() => {
    console.log('--- DEBUG CALENDAR FILTERS ---');
    console.log('1. Valor actual de filters.dealer:', filters.dealer);
    console.log('2. Opciones de dealers disponibles:', options.dealers);
    console.log('3. isDealerDisabled:', isDealerDisabled);
    console.log('------------------------------');
  }, [filters.dealer, options.dealers, isDealerDisabled]);

  const courseOptions = coursesFilter.map((c) => ({
    'key': c.id,
    'value': c.id,
    'text': c.course || c.description,
  }));

  return (
    <Segment raised>
      <h4 className="ui dividing header">PERIODO</h4>
      <div style={{
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'gap': '4px',
        'marginBottom': '1em',
      }}>
        <Button
          icon="angle left"
          size="mini"
          circular
          onClick={() => setCurrentYear(currentYear - 1)}
        />
        <Dropdown
          search
          selection
          compact
          scrolling
          options={yearOptions}
          value={currentYear}
          onChange={(e, {value}) => setCurrentYear(value)}
          style={{
            'width': '85px',
            'padding': '0.5em',
            'fontWeight': 'bold',
            'color': '#2185d0',
            'textAlign': 'center',
          }}
        />
        <Button
          icon="angle right"
          size="mini"
          circular
          onClick={() => setCurrentYear(currentYear + 1)}
        />
      </div>
      <h4 className="ui dividing header">FILTROS</h4>
      <Form size="mini">
        <Form.Field>
          <label>Curso</label>
          <Dropdown
            placeholder="Curso"
            fluid
            selection
            clearable
            search
            value={filters.course}
            options={courseOptions}
            onChange={(e, {value}) => onFilterChange('course', value)}
          />
        </Form.Field>
        <Form.Field>
          <label>Instructor</label>
          <Dropdown
            placeholder="Instructor"
            fluid
            selection
            clearable
            search
            value={filters.instructor}
            options={options.instructors}
            onChange={(e, {value}) => onFilterChange('instructor', value)}
          />
        </Form.Field>
        <Form.Field>
          <label>Dealer</label>
          <Dropdown
            placeholder="Dealer"
            fluid
            selection
            clearable={!isDealerDisabled}
            disabled={isDealerDisabled}
            search
            value={filters.dealer}
            options={options.dealers}
            onChange={(e, {value}) => {
              onFilterChange('dealer', value);
            }}
          />
        </Form.Field>
        <Button fluid size="mini" onClick={onClear}>Limpiar Filtros</Button>
      </Form>
      <Divider />
      <List relaxed verticalAlign="middle">
        <List.Item style={{'display': 'flex', 'justifyContent': 'space-between',
          'alignItems': 'center', 'padding': '4px 0'}}>
          <div style={{'display': 'flex', 'alignItems': 'center'}}>
            <Icon name="angle down" color="blue" />
            <List.Content>
              <List.Header style={{'fontSize': '0.9em'}}>Total cursos {currentYear}</List.Header>
            </List.Content>
          </div>
          <div style={{'fontWeight': 'bold', 'color': '#2185d0'}}>{totalCount}</div>
        </List.Item>

        {selectedData && (
          <>
            <Divider style={{'margin': '10px 0'}} />
            <List.Item style={{'display': 'flex', 'justifyContent': 'space-between',
              'alignItems': 'center', 'padding': '4px 0'}}>
              <div style={{'display': 'flex', 'alignItems': 'center'}}>
                <Icon name="user" color="green" />
                <List.Content>
                  <List.Header style={{'fontSize': '0.9em'}}>Participantes</List.Header>
                </List.Content>
              </div>
              <div style={{'fontWeight': 'bold', 'color': '#21ba45'}}>{selectedData.participants || 0}</div>
            </List.Item>
            
            <List.Item style={{'paddingTop': '10px'}}>
              <div style={{'display': 'flex', 'alignItems': 'center', 'marginBottom': '8px'}}>
                <Icon name="columns" color="orange" />
                <List.Content>
                  <List.Header style={{'fontSize': '0.9em'}}>Desglose</List.Header>
                </List.Content>
              </div>
              <List divided size="tiny" style={{'marginTop': '0', 'background': '#f9f9f9',
                'padding': '8px', 'borderRadius': '4px'}}>
                {selectedData.concesionarios?.map((c, i) => (
                  <List.Item key={i} style={{'padding': '6px 0', 'display': 'flex',
                    'justifyContent': 'space-between', 'gap': '10px'}}>
                    <span style={{'flex': '1', 'wordBreak': 'break-word', 'fontSize': '0.85em', 'color': '#666'}}>
                      {dealers.find((d) => d.ruc === c.ruc)?.description || c.ruc}
                    </span>
                    <strong style={{'whiteSpace': 'nowrap', 'color': '#f2711c', 'fontSize': '0.85em'}}>
                      {c.participantes}
                    </strong>
                  </List.Item>
                ))}
                {(!selectedData.concesionarios || selectedData.concesionarios.length === 0) && (
                  <div style={{'textAlign': 'center', 'color': '#999',
                    'fontSize': '0.8em', 'padding': '5px 0'}}>Sin concesionarios</div>
                )}
              </List>
            </List.Item>
          </>
        )}
      </List>
    </Segment>
  );
};

export default CalendarFilters;
